export function isContactReceiver(receiver) {
    return receiver.type === 'contact';
}
export function isGroupReceiver(receiver) {
    return receiver.type === 'group';
}
export function isDistributionListReceiver(receiver) {
    return receiver.type === 'distributionList';
}
export function isValidReceiverType(receiverType) {
    switch (receiverType) {
        case 'me':
        case 'contact':
        case 'group':
        case 'distributionList':
            return true;
    }
    return false;
}
export function isValidDisconnectReason(reason) {
    switch (reason) {
        case 'stop':
        case 'delete':
        case 'disable':
        case 'replace':
            return true;
    }
    return false;
}
export function isTextNode(node) {
    return node.nodeType === node.TEXT_NODE;
}
export function isElementNode(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
export function isEmojiInfo(val) {
    return typeof val === 'object'
        && val.emojiString !== undefined
        && val.imgPath !== undefined
        && val.codepoint !== undefined;
}
export function controllerModelHasMembers(cm) {
    return cm.receiverType === 'group' || cm.receiverType === 'distributionList';
}
export function isKeyboardEvent(ev) {
    return ev.type === 'keydown' || ev.type === 'keypress' || ev.type === 'keyup';
}
